export default {
  default: () => import("/var/www/ao-stom/data/www/ao-stom.ru-nuxt/layouts/default.vue").then(m => m.default || m)
}